export function passwordRequirements(value) {
    const regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[@_!#$%^&*()<>?/|}{~:])(?!.*\s).{8,20}$/

    return regex.test(value)
}

export function digitsAndCharactersOnly(value) {
    if (!value) return true
    const regex = /^[a-zA-Z0-9]+$/
    return regex.test(value)
}

export function pdfFileName(value) {
    if (!value) return false

    const regex = /^[a-zA-Z0-9_-]+\.pdf$/
    return regex.test(value)
}

export function validRuleIllegalCharactersJobName(value) {
    const regex = /[/:'\\"?*<>|()[\]$#^&@{}~]/

    return regex.test(value)
}

export function validRuleNameLength(value, maxLength = 80) {
    return value?.length <= maxLength
}

export function validRuleIllegalCharacters(value) {
    if (!value) return false
    const regex = /[/:'\\"?*<>|()[\]%$#^&@{}~]/

    return regex.test(value)
}

export function isCurrencyString(value) {
    const normalized = value == null ? '' : String(value).trim()
    if (!normalized) return false

    return /^\d+(,\d{2})$/.test(normalized)
}

export function isPositiveInteger(value) {
    return Number.isInteger(Number(value)) && Number(value) > 0
}
